<template>
    <Application
        :mynav="menuNav"
        @DangXuat="DangXuat"
        PhienBan="0.0.211005.1"
        :propModelToast="modelToast"
    >
        <template v-slot:default>
            <slot />
        </template>
    </Application>
</template>

<script>
import Application from "@sonphat/common-v1/components/application.vue";

export default {
    components: { Application },
    data() {
        return {
            menuNav: [
                {
                    id: "Home",
                    text: "Trang chủ",
                    icon: "home",
                    to: "/",
                    expanded: false,
                },

                // QLTT
                {
                    id: "CHDDT",
                    text: "Cổng hóa đơn điện tử",
                    icon: "",
                    // external: true,
                    expanded: false,
                },
                {
                    id: this.$t("namePath.QuanLyBenXe"),
                    parent: "CHDDT",
                    text: "Danh sách ký hiệu",
                    icon: "",
                    to: "/Cong-Hoa-Don-Dien-Tu",
                    expanded: false,
                },
                {
                    id: this.$t("namePath.QuanLyLaiXe"),
                    parent: "CHDDT",
                    text: "Danh sách loại hóa đơn doanh nghiệp sử dụng",
                    icon: "",
                    to: "/Loai-Hoa-Don-Doanh-Nghiep-Su-Dung",
                    expanded: false,
                },
                // {
                //     id: this.$t("namePath.QuanLyLuongTuyen"),
                //     parent: "QLTT",
                //     text: this.$t("namePath.QuanLyLuongTuyen"),
                //     icon: "",
                //     to: "/Quan-Ly-Luong-Tuyen",
                //     expanded: false,
                // },
                // {
                //     id: this.$t("namePath.QuanLyPhuongTien"),
                //     parent: "QLTT",
                //     text: this.$t("namePath.QuanLyPhuongTien"),
                //     icon: "",
                //     to: "/Quan-Ly-Phuong-Tien",
                //     expanded: false,
                // },
            ],
            openState: false,
            modelToast: {
                isVisible: false,
                message: "",
                type: "success",
            },
        };
    },
    methods: {
        DangXuat() {
            this.$Core.Auth.Logout();
        },
    },
    mounted() {
        let self = this;
        this.emitter.on("onToast", (params) => {
            self.modelToast = params;
        });
    },
};
</script>

<style scoped>
::v-deep .icon-toast .dx-icon {
    font-size: 36px;
}
::v-deep .icon-toast {
    position: relative;
    left: -16px;
}
</style>
